import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

const AuthContext = createContext({
  user: undefined,
  loading: true,
  refresh: () => {},
  logout: () => {},
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);  // undefined=loading, null=anon, object=user

  const refresh = useCallback(async () => {
    try {
      const res = await fetch('/api/auth/me', { credentials: 'include' });
      if (!res.ok) return setUser(null);
      const data = await res.json();
      setUser(data || null);
    } catch {
      setUser(null);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const logout = useCallback(async () => {
    await fetch('/api/auth/logout', { method: 'POST', credentials: 'include' });
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{
      user,
      loading: user === undefined,
      refresh,
      logout,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

// AuthProvider 내부에서 라우트 변경 감지 → page-view 기록.
// BrowserRouter 안에 있어야 동작.
export function PageViewTracker() {
  const { user } = useAuth();
  const location = useLocation();
  useEffect(() => {
    if (!user) return;
    fetch('/api/activity/page-view', {
      method: 'POST',
      credentials: 'include',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        path: location.pathname,
        query: location.search || null,
      }),
    }).catch(() => {});
  }, [location, user]);
  return null;
}

export const useAuth = () => useContext(AuthContext);
